export const isBannerOutdated = (timestampMs: string): boolean => {
  const date = new Date(Number(timestampMs));

  date.setDate(date.getDate() + 7);

  return Date.now() > date.getTime();
};
